<template>
    <v-card
        class="pb-5"
        :width="widthProp"
        elevation="0"
        style="border-radius: 10px"
    >
        <v-card-text>
            <v-form
                v-model="student_parent"
                ref="form"
                :disabled="disabledRules"
            >
                <v-row>
                    <v-col md="8" sm="6" xs="4" style="padding: 20px 12px 8px;">
                        <div class="prompt-title">{{ $t("message.form.topics.fatherInformation") }}</div>
                        <span class="remark-text"> * {{ $t('message.common.remarkFillShort') }}</span>
                    </v-col>
                    <!-- <v-col md="4" sm="6" xs="8">
                        <v-row no-gutters justify="end">
                            <v-checkbox
                                :input-value="!hasFather"
                                :label='$t("message.form.parentData.fatherNotListed")'
                                color="orange"
                                hide-details="auto"
                                class="mt-2"
                                @click="toggleDad()"
                            ></v-checkbox>
                        </v-row>
                    </v-col> -->
                </v-row>
                <v-row v-if="hasFather">
                    <v-col cols="12" xs="3" sm="3" md="3" class="py-0 my-1 pr-sm-2 pr-xs-3">
                        <div
                            class="pa-1 form-label"
                            hide-details="auto"
                            style="width: 200px"
                        >
                            {{ $t("message.form.studentData.title") }}
                            <strong>*</strong>
                        </div>
                        <!-- <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillTitle")'
                            :items="prefixes"
                            item-text="text_th"
                            item-value="id"
                            v-model="father.prefix_th"
                            v-on:change="processPrefix_TH(father)"
                            @change="sameData(father)"
                            :rules="parent_prefix_rule"
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-select> -->
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillTitleTH")'
                            v-model="father.prefix_th"
                            v-on:keypress="isThaiLetter($event)"
                            v-on:change="sameData(father)"
                            :rules="parent_prefix_rule"
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" xs="9" sm="9" md="9" class="py-0 my-1">
                        <v-row>
                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                >
                                    {{$t("message.form.studentData.firstNameTH")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillFirstNameTH")'
                                    v-model="father.name_th"
                                    v-on:keypress="isThaiLetter($event)"
                                    v-on:change="sameData(father)"
                                    :rules="parent_name_th_rule"
                                    ><template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                    style="width:160px"
                                >
                                    {{$t("message.form.studentData.lastNameTH")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillLastNameTH")'
                                    v-model="father.surname_th"
                                    v-on:keypress="isThaiLetter($event)"
                                    v-on:change="sameData(father)"
                                    :rules="parent_surname_th_rule"
                                    ><template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" xs="3" sm="3" md="3" class="py-0 my-1 pr-sm-2 pr-xs-3">
                        <div
                            class="pa-1 form-label"
                            hide-details="auto"
                            style="width: 200px"
                        >
                            {{ $t("message.form.studentData.title") }}
                            <strong>*</strong>
                        </div>
                        <!-- <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillTitle")'
                            :items="prefixEN"
                            v-model="father.prefix_en"
                            v-on:change="processPrefix_EN(father)"
                            @change="sameData(father)"
                            :rules="parent_prefix_rule"
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-select> -->
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillTitleEN")'
                            v-model="father.prefix_en"
                            v-on:keypress="isEngLetter($event)"
                            v-on:change="sameData(father)"
                            :rules="parent_prefix_rule"
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" xs="9" sm="9" md="9" class="py-0 my-1">
                        <v-row>
                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                >
                                    {{$t("message.form.studentData.firstNameEN")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillFirstNameEN")'
                                    v-model="father.name_en"
                                    v-on:keypress="isEngLetter($event)"
                                    v-on:change="sameData(father)"
                                    :rules="parent_name_en_rule"
                                    ><template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                    style="width:160px"
                                >
                                    {{$t("message.form.studentData.lastNameEN")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillLastNameEN")'
                                    v-model="father.surname_en"
                                    v-on:keypress="isEngLetter($event)"
                                    v-on:change="sameData(father)"
                                    :rules="parent_surname_en_rule"
                                    ><template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.studentData.mobileNo") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            placeholder="000 000 0000"
                            v-model="father.phone_number"
                            v-on:change="sameData(father)"
                            v-mask="'### ### ####'"
                            required
                            :rules="numberRules"
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field
                        >
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2" v-if="this.stepActive == 5">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.email") }}
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillEmail")'
                            v-model="father.email"
                            v-on:change="sameData(father)"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.career") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillCareer")'
                            v-model="father.career"
                            :rules="parent_career_rule"
                            v-on:change="sameData(father)"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2" >
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.position") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillPosition")'
                            v-model="father.position"
                            :rules="parent_position_rule"
                            v-on:change="sameData(father)"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2" >
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.workPlace") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillWorkPlace")'
                            v-model="father.work_place"
                            :rules="parent_work_place_rule"
                            v-on:change="sameData(father)"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2" v-if="this.stepActive == 5">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.salary") }}
                        </div>
                        <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillSalary")'
                            v-model="father.salary"
                            :items="salaryRanges"
                            :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                            item-value="value"
                            v-on:change="sameData(father)"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="12" md="12" v-if="this.stepActive == 5">
                        <v-checkbox
                            :label='$t("message.form.parentData.usePresentAddress")'
                            color="orange"
                            hide-details="auto"
                            class="mt-n1"
                            v-model="father.is_same_student_address"
                            v-on:change="sameData(father)"
                        ></v-checkbox>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" v-if="this.stepActive == 5">
                        <AddressForm
                            form="Father"
                            @updateSameAddress="updateSameAddress"
                            @loadingUpdate="loadingUpdate"
                            :showAddress="!father.is_same_student_address"
                            ref="fatherAddress"
                            :from="from"
                            :dbAddress="father"
                            v-if="isSet"
                        />
                    </v-col>
                </v-row>

                <v-row class="pt-7 px-3">
                    <v-divider></v-divider>
                </v-row>

                <v-row>
                    <v-col md="8" sm="6" xs="4" style="padding: 14px 12px 8px;">
                        <div class="mt-0 mr-0 prompt-title">{{ $t("message.form.topics.motherInformation") }}</div>
                        <span class="remark-text"> * {{ $t('message.common.remarkFillShort') }}</span>
                    </v-col>
                    <!-- <v-col md="4" sm="6" xs="8" class="d-flex align-center">
                        <v-row no-gutters class="flex-row-reverse">
                            <v-checkbox
                                :input-value="!hasMother"
                                :label='$t("message.form.parentData.motherNotListed")'
                                color="orange"
                                hide-details="auto"
                                class="mt-n1"
                                @click="toggleMom()"
                            ></v-checkbox>
                        </v-row>
                    </v-col> -->
                </v-row>

                <v-row v-if="hasMother">
                    <v-col cols="12" xs="3" sm="3" md="3" class="py-0 my-1 pr-sm-2 pr-xs-3">
                        <div
                            class="pa-1 form-label"
                            hide-details="auto"
                            style="width: 200px"
                        >
                            {{ $t("message.form.studentData.title") }}
                            <strong>*</strong>
                        </div>
                        <!-- <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillTitle")'
                            :items="prefixes"
                            item-text="text_th"
                            item-value="id"
                            v-model="mother.prefix_th"
                            v-on:change="processPrefix_TH(mother)"
                            @change="sameData(mother)"
                            :rules="parent_prefix_rule"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-select> -->
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillTitleTH")'
                            v-model="mother.prefix_th"
                            v-on:keypress="isThaiLetter($event)"
                            v-on:change="sameData(mother)"
                            :rules="parent_prefix_rule"
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" xs="9" sm="9" md="9" class="py-0 my-1">
                        <v-row>
                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                >
                                    {{$t("message.form.studentData.firstNameTH")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillFirstNameTH")'
                                    v-model="mother.name_th"
                                    v-on:keypress="isThaiLetter($event)"
                                    v-on:change="sameData(mother)"
                                    :rules="parent_name_th_rule"
                                    required
                                    ><template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                >
                                    {{$t("message.form.studentData.lastNameTH")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillLastNameTH")'
                                    v-model="mother.surname_th"
                                    v-on:keypress="isThaiLetter($event)"
                                    v-on:change="sameData(mother)"
                                    :rules="parent_surname_th_rule"
                                    required
                                >
                                    <template #message="{ message }">
                                        {{ $t(message) }}
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" xs="3" sm="3" md="3" class="py-0 my-1 pr-sm-2 pr-xs-3">
                        <div
                            class="pa-1 form-label"
                            hide-details="auto"
                            style="width: 200px"
                        >
                            {{ $t("message.form.studentData.title") }}
                            <strong>*</strong>
                        </div>
                        <!-- <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillTitle")'
                            :items="prefixEN"
                            v-model="mother.prefix_en"
                            v-on:change="processPrefix_EN(mother)"
                            @change="sameData(mother)"
                            :rules="parent_prefix_rule"
                            required
                        >
                            <template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-select> -->
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillTitleEN")'
                            v-model="mother.prefix_en"
                            v-on:keypress="isEngLetter($event)"
                            v-on:change="sameData(mother)"
                            :rules="parent_prefix_rule"
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" xs="9" sm="9" md="9" class="py-0 my-1">
                        <v-row>
                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                >
                                    {{$t("message.form.studentData.firstNameEN")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillFirstNameEN")'
                                    v-model="mother.name_en"
                                    v-on:keypress="isEngLetter($event)"
                                    v-on:change="sameData(mother)"
                                    :rules="parent_name_en_rule"
                                    required
                                    ><template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                >
                                    {{$t("message.form.studentData.lastNameEN")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillLastNameEN")'
                                    v-model="mother.surname_en"
                                    v-on:keypress="isEngLetter($event)"
                                    :rules="parent_surname_en_rule"
                                    v-on:change="sameData(mother)"
                                    required
                                    ><template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.studentData.mobileNo") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            placeholder="000 000 0000"
                            v-model="mother.phone_number"
                            v-mask="'### ### ####'"
                            v-on:change="sameData(mother)"
                            :rules="numberRules"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field
                        >
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2" v-if="this.stepActive == 5">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.email") }}
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillEmail")'
                            v-model="mother.email"
                            required
                            v-on:change="sameData(mother)"
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field
                        >
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.career") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillCareer")'
                            v-model="mother.career"
                            :rules="parent_career_rule"
                            v-on:change="sameData(mother)"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.position") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillPosition")'
                            v-model="mother.position"
                            :rules="parent_position_rule"
                            v-on:change="sameData(mother)"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2" >
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.workPlace") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillWorkPlace")'
                            v-model="mother.work_place"
                            :rules="parent_work_place_rule"
                            v-on:change="sameData(mother)"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2" v-if="this.stepActive == 5">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.salary") }}
                        </div>
                        <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillSalary")'
                            v-model="mother.salary"
                            :items="salaryRanges"
                            :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                            item-value="value"
                            v-on:change="sameData(mother)"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="12" md="12" v-if="this.stepActive == 5">
                        <v-checkbox
                            :label='$t("message.form.parentData.usePresentAddress")'
                            color="orange"
                            hide-details="auto"
                            class="mt-n1"
                            v-model="mother.is_same_student_address"
                            v-on:change="sameData(mother)"
                        ></v-checkbox>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" v-if="this.stepActive == 5">
                        <AddressForm
                            form="Mother"
                            @updateSameAddress="updateSameAddress"
                            @loadingUpdate="loadingUpdate"
                            :showAddress="!mother.is_same_student_address"
                            ref="motherAddress"
                            :from="from"
                            :dbAddress="mother"
                            v-if="isSet"
                        />
                    </v-col>
                </v-row>

                <v-row class="pt-7 px-3">
                    <v-divider></v-divider>
                </v-row>

                <v-row >
                    <v-col md="6" sm="6" xs="4" cols="12" style="padding: 14px 12px 8px;">
                        <div class="my-0 py-0 mr-0 prompt-title" >{{ $t("message.form.topics.guardianInformation") }}</div>
                        <span class="remark-text"> * {{ $t('message.common.remarkFillShort') }}</span>
                    </v-col>
                    <v-col md="6" sm="6" xs="8" cols="12">
                        <v-row>
                            <v-col md="6" sm="6" xs="3" class="d-flex justify-sm-end justify-xs-start">
                                <v-checkbox
                                    :input-value="checkFather"
                                    :label='$t("message.form.parentData.father")'
                                    color="orange"
                                    hide-details="auto"
                                    class="mt-n1"
                                    :disabled="checkMother || !hasFather"
                                    @click="chooseFatherAsParent"
                                ></v-checkbox>
                            </v-col>
                            <v-col md="6" sm="6" xs="3" class="d-flex justify-sm-end justify-xs-start">
                                <v-checkbox
                                    :input-value="checkMother"
                                    :label='$t("message.form.parentData.mother")'
                                    color="orange"
                                    hide-details="auto"
                                    class="mt-n1"
                                    :disabled="checkFather || !hasMother"
                                    @click="chooseMotherAsParent"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" xs="3" sm="3" md="3" class="py-0 my-1 pr-sm-2 pr-xs-3">
                        <div
                            class="pa-1 form-label"
                            hide-details="auto"
                            style="width: 200px"
                        >
                            {{ $t("message.form.studentData.title") }}
                            <strong>*</strong>
                        </div>
                        <!-- <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder="
                                $t('message.form.studentData.fillTitle')
                            "
                            :disabled="toggleDisableGuardian"
                            v-model="guardian.prefix_th"
                            :items="prefixes"
                            item-text="text_th"
                            item-value="id"
                            v-on:change="processPrefix_TH(guardian)"
                            :rules="parent_prefix_rule"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-select> -->
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillTitleTH")'
                            v-model="guardian.prefix_th"
                            v-on:keypress="isThaiLetter($event)"
                            :rules="parent_prefix_rule"
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" xs="9" sm="9" md="9" class="py-0 my-1">
                        <v-row>
                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                >
                                    {{$t("message.form.studentData.firstNameTH")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillFirstNameTH")'
                                    :disabled="toggleDisableGuardian"
                                    v-model="guardian.name_th"
                                    v-on:keypress="isThaiLetter($event)"
                                    :rules="parent_name_th_rule"
                                    required
                                    ><template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                >
                                    {{$t("message.form.studentData.lastNameTH")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillLastNameTH")'
                                    :disabled="toggleDisableGuardian"
                                    v-model="guardian.surname_th"
                                    v-on:keypress="isThaiLetter($event)"
                                    :rules="parent_surname_th_rule"
                                    required
                                    ><template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" xs="3" sm="3" md="3" class="py-0 my-1 pr-sm-2 pr-xs-3">
                        <div
                            class="pa-1 form-label"
                            hide-details="auto"
                            style="width: 200px"
                        >
                            {{ $t("message.form.studentData.title") }}
                            <strong>*</strong>
                        </div>
                        <!-- <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillTitle")'
                            :disabled="toggleDisableGuardian"
                            v-model="guardian.prefix_en"
                            :items="prefixEN"
                            v-on:change="processPrefix_EN(guardian)"
                            :rules="parent_prefix_rule"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-select> -->
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillTitleEN")'
                            v-model="guardian.prefix_en"
                            v-on:keypress="isEngLetter($event)"
                            :rules="parent_prefix_rule"
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" xs="9" sm="9" md="9" class="py-0 my-1">
                        <v-row>
                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-2 pr-xs-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                >
                                    {{$t("message.form.studentData.firstNameEN")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillFirstNameEN")'
                                    :disabled="toggleDisableGuardian"
                                    v-model="guardian.name_en"
                                    v-on:keypress="isEngLetter($event)"
                                    :rules="parent_name_en_rule"
                                    required
                                    ><template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="pl-sm-2 pr-sm-3 pl-xs-3">
                                <div
                                    class="pa-1 form-label"
                                    hide-details="auto"
                                >
                                    {{$t("message.form.studentData.lastNameEN")}}
                                    <strong>*</strong>
                                </div>
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details="auto"
                                    v-bind:placeholder='$t("message.form.studentData.fillLastNameEN")'
                                    :disabled="toggleDisableGuardian"
                                    v-model="guardian.surname_en"
                                    v-on:keypress="isEngLetter($event)"
                                    :rules="parent_surname_en_rule"
                                    required
                                    ><template #message="{ message }">
                                        {{ $t(message) }}
                                    </template></v-text-field
                                >
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.studentData.mobileNo") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            placeholder="000 000 0000"
                            :disabled="toggleDisableGuardian"
                            v-model="guardian.phone_number"
                            v-mask="'### ### ####'"
                            :rules="numberRules"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field
                        >
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2" v-if="this.stepActive == 5">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.email") }}
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillEmail")'
                            :disabled="toggleDisableGuardian"
                            v-model="guardian.email"
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field
                        >
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.career") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillCareer")'
                            :disabled="toggleDisableGuardian"
                            v-model="guardian.career"
                            :rules="parent_career_rule"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.position") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillPosition")'
                            :disabled="toggleDisableGuardian"
                            v-model="guardian.position"
                            :rules="parent_position_rule"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2" >
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.workPlace") }}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillWorkPlace")'
                            :disabled="toggleDisableGuardian"
                            v-model="guardian.work_place"
                            :rules="parent_work_place_rule"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template>
                        </v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="4" class="py-0 my-1 pl-sm-2 pr-sm-2" v-if="this.stepActive == 5">
                        <div class="pa-1 form-label" hide-details="auto">
                            {{ $t("message.form.parentData.salary") }}
                        </div>
                        <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillSalary")'
                            :disabled="toggleDisableGuardian"
                            v-model="guardian.salary"
                            :items="salaryRanges"
                            :item-text="locale == 'th' ? 'name_th' : 'name_en'"
                            item-value="value"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="12" md="12" v-if="this.stepActive == 5">
                        <v-checkbox
                            :label='$t("message.form.parentData.usePresentAddress")'
                            color="orange"
                            hide-details="auto"
                            class="mt-n1"
                            v-model="guardian.is_same_student_address"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="this.stepActive == 5">
                        <AddressForm
                            :showAddress="!guardian.is_same_student_address"
                            @loadingUpdate="loadingUpdate"
                            :is_same_other_address="checkFather || checkMother"
                            :otherAddress="otherAddress"
                            :fetchTrigger="fetchTrigger"
                            ref="guardianAddress"
                            :from="from"
                            :dbAddress="guardian"
                            v-if="isSet"
                        />
                    </v-col>
                </v-row>

                <v-row class="pt-7 px-3">
                    <v-divider></v-divider>
                </v-row>

                <v-row>
                    <v-col cols="12" md="6">
                        <div class="mt-0 mr-0 prompt-title">
                            {{ $t("message.form.topics.other") }}
                        </div>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="py-0 my-1">
                        <div class="pa-1 form-label">
                            {{ $t("message.form.parentData.familyStatus") }}
                        </div>
                        <v-radio-group
                            row
                            class="py-0 mt-2"
                            hide-details="auto"
                            v-model="student_parent_detail.family_status"
                        >
                            <v-row>
                                <v-col cols="12" sm="6" :md="responsiveWithFrom" v-for="item in familyStatus" :key="item.value">
                                    <v-radio
                                        v-bind:label="$t(item.text)"
                                        :value="item.value"
                                        color="orange"
                                    ></v-radio>
                                </v-col>
                            </v-row>
                        </v-radio-group>
                    </v-col>
                </v-row>

                <v-row class="pt-2">
                    <!-- siblings_study_together -->
                    <v-col cols="12" sm="12" md="12" class="py-0 my-1">
                        <div class="pa-1 form-label">
                            {{ $t("message.form.parentData.siblings_study_together") }}
                        </div>
                        <v-radio-group
                            row
                            class="py-0 mt-2"
                            hide-details="auto"
                            v-model="student_parent_detail.is_siblings_study_together"
                        >
                            <v-row>
                                <v-col cols="12" sm="6" md="4" xl="3" v-for="item in yesNoStatus" :key="item.value" >
                                    <v-radio
                                        v-bind:label="$t(item.text)"
                                        :value="item.value"
                                        color="orange"
                                    ></v-radio>
                                </v-col>
                            </v-row>
                        </v-radio-group>
                    </v-col>
                </v-row>

                <v-row class="pt-2" v-if="student_parent_detail.is_siblings_study_together">
                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <div
                            class="pa-1 form-label"
                            hide-details="auto"
                        >
                            {{$t("message.form.studentData.firstName")}}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillFirstName")'
                            v-model="student_parent_detail.siblings_name"
                            :rules="siblings_name_rule"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field
                        >
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <div
                            class="pa-1 form-label"
                            hide-details="auto"
                        >
                            {{$t("message.form.studentData.lastName")}}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillLastName")'
                            v-model="student_parent_detail.siblings_surname"
                            :rules="siblings_surname_rule"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field
                        >
                    </v-col>
                </v-row>

                <v-row class="pt-2" v-if="student_parent_detail.is_siblings_study_together">
                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <div
                            class="pa-1 form-label"
                            hide-details="auto"
                        >
                            {{$t("message.form.studentData.grade")}}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillGrade")'
                            v-model="student_parent_detail.siblings_grade"
                            :rules="siblings_grade_rule"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field
                        >
                    </v-col>

                    <v-col cols="12" sm="6" md="6" class="py-0">
                        <div
                            class="pa-1 form-label"
                            hide-details="auto"
                        >
                            {{$t("message.form.studentData.house")}}
                            <strong>*</strong>
                        </div>
                        <v-text-field
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.studentData.fillHouse")'
                            v-model="student_parent_detail.siblings_house"
                            :rules="siblings_house_rule"
                            required
                            ><template #message="{ message }">
                                {{ $t(message) }}
                            </template></v-text-field
                        >
                    </v-col>
                </v-row>

                <v-row class="pt-2">
                    <v-col cols="12" sm="12" md="12" v-if="this.stepActive == 5">
                        <div
                            class="pa-1 form-label"
                            hide-details="auto"
                            style="display: absolute; width: 400px"
                        >
                            {{$t("message.form.parentData.personTakeCare")}}
                        </div>
                        <v-select
                            dense
                            outlined
                            hide-details="auto"
                            v-bind:placeholder='$t("message.form.parentData.fillAllowance")'
                            :items="studentAllowances"
                            :item-text="locale == 'th' ? 'text_th' : 'text_en'"
                            item-value="value"
                            v-model="student_parent_detail.student_allowance_by"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
import { FAMILY_STATUS, YES_NO_STATUS, STUDENT_ALLOWANCE, RegistrationStatusEnum } from "@/constants";
import * as services from "@/services";
import AddressForm from "../fileElement/AddressForm.vue";
import i18n from '@/i18n';

export default {
    name: "StudentParent",
    data: () => ({
        student_parent: false,
        // check has parent
        hasFather: true,
        hasMother: true,
        toggleDisableGuardian: false,

        // check who is parent
        checkMother: false,
        checkFather: false,

        // toggle address
        showAddressMother: true,
        showAddressFather: true,
        showAddressGuardian: true,

        // get data
        student_parent_detail: {
            family_status: 'TOGETHER',
            is_siblings_study_together: false,
            siblings_name: null,
            siblings_surname: null,
            siblings_grade: null,
            siblings_house: null,
            student_allowance_by: null,
        },
        mother: {
            prefix_id: null,
            prefix_th: "",
            prefix_en: "",
            name_th: "",
            name_en: "",
            surname_th: "",
            surname_en: "",
            phone_number: "",
            email: "",
            salary: 0,
            career: "",
            position: "",
            work_place: "",
            parent_type: "MOTHER",
            is_guardian: false,
            is_same_student_address: false,
        },
        father: {
            prefix_id: null,
            prefix_th: "",
            prefix_en: "",
            name_th: "",
            name_en: "",
            surname_th: "",
            surname_en: "",
            phone_number: "",
            email: "",
            salary: 0,
            career: "",
            position: "",
            work_place: "",
            parent_type: "FATHER",
            is_guardian: false,
            is_same_student_address: false,
        },
        guardian: {
            prefix_id: null,
            prefix_th: "",
            prefix_en: "",
            name_th: "",
            name_en: "",
            surname_th: "",
            surname_en: "",
            phone_number: "",
            email: "",
            salary: 0,
            career: "",
            position: "",
            work_place: "",
            parent_type: "GUARDIAN",
            is_guardian: true,
            is_same_student_address: false,
        },

        isSet: false,
        otherAddress: null,
        fetchTrigger: false,
        prefixes: [],
        prefixEN: [],
        salaryRanges: [],
        studentAllowances: STUDENT_ALLOWANCE,
        familyStatus: FAMILY_STATUS,
        yesNoStatus: YES_NO_STATUS,
        numberRules: [
            (v) => !!v || "message.form.studentData.fillMobileNo",
            (v) => v?.length == 12 || "message.form.studentData.leastMobileNo",
        ],
        e: [],
        parent_prefix_rule: [
            (v) => !!v || "message.form.studentData.invalidTitle",
        ],
        parent_name_th_rule: [
            (v) => !!v || "message.form.studentData.fillFirstNameTH",
        ],
        parent_surname_th_rule: [
            (v) => !!v || "message.form.studentData.fillLastNameTH",
        ],
        parent_name_en_rule: [
            (v) => !!v || "message.form.studentData.fillFirstNameEN",
        ],
        parent_surname_en_rule: [
            (v) => !!v || "message.form.studentData.fillLastNameEN",
        ],
        parent_career_rule: [
            (v) => !!v || "message.form.parentData.fillCareer",
        ],
        parent_position_rule: [
            (v) => !!v || "message.form.parentData.fillPosition",
        ],
        parent_work_place_rule: [
            (v) => !!v || "message.form.parentData.fillWorkPlace",
        ],
        siblings_name_rule: [
            (v) => !!v || "message.form.studentData.fillFirstName",
        ],
        siblings_surname_rule: [
            (v) => !!v || "message.form.studentData.fillLastName",
        ],
        siblings_grade_rule: [
            (v) => !!v || "message.form.studentData.fillGrade",
        ],
        siblings_house_rule: [
            (v) => !!v || "message.form.studentData.fillHouse",
        ],
    }),
    methods: {
        loadingUpdate(value) {
            this.$emit("loadingUpdate", value);
        },
        toggleDad() {
            // change disable father
            this.hasFather = !this.hasFather;

            // deselect father as parent
            if (this.checkFather && this.hasFather == false) {
                this.checkFather = false;
                this.toggleDisableGuardian = false;
                this.defaultGuardianData();
            }
        },
        toggleMom() {
            this.hasMother = !this.hasMother;
            if (this.checkMother && this.hasMother == false) {
                this.checkMother = false;
                this.toggleDisableGuardian = false;
                this.defaultGuardianData();
            }
        },
        defaultGuardianData() {
            this.guardian.prefix_id = null;
            this.guardian.prefix_th = undefined;
            this.guardian.prefix_en = undefined;
            this.guardian.name_th = undefined;
            this.guardian.name_en = undefined;
            this.guardian.surname_th = undefined;
            this.guardian.surname_en = undefined;
            this.guardian.phone_number = undefined;
            this.guardian.email = undefined;
            this.guardian.salary = undefined;
            this.guardian.career = undefined;
            this.guardian.position = undefined;
            this.guardian.work_place = undefined;
            this.guardian.parent_type = "GUARDIAN";
            this.guardian.is_same_student_address = false;
        },
        chooseFatherAsParent(){
            this.checkFather = !this.checkFather;
            this.toggleDisableGuardian = this.checkFather;
            this.mother.is_guardian = this.checkMother;
            this.father.is_guardian = this.checkFather;
            if(this.toggleDisableGuardian == true){
                this.autoFillGuardianDataFromOther(this.father)
            }
            else{
                this.defaultGuardianData()
            }
        },
        chooseMotherAsParent(){
            this.checkMother = !this.checkMother;
            this.toggleDisableGuardian = this.checkMother;
            this.mother.is_guardian = this.checkMother;
            this.father.is_guardian = this.checkFather;
            if(this.toggleDisableGuardian == true){
                this.autoFillGuardianDataFromOther(this.mother)
            }
            else{
                this.defaultGuardianData()
            }
        },
        autoFillGuardianDataFromOther(obj){
            this.guardian.prefix_id = obj?.prefix_id;
            this.guardian.prefix_th = obj?.prefix_th;
            this.guardian.prefix_en = obj?.prefix_en;
            this.guardian.name_th = obj?.name_th;
            this.guardian.name_en = obj?.name_en;
            this.guardian.surname_th = obj?.surname_th;
            this.guardian.surname_en = obj?.surname_en;
            this.guardian.phone_number = obj?.phone_number;
            this.guardian.career = obj?.career;
            this.guardian.position = obj?.position;
            this.guardian.work_place = obj?.work_place;
            if(this.stepActive == 5 || this.from == "candidates"){
                this.guardian.email = obj?.email;
                this.guardian.salary = obj?.salary;
                this.guardian.is_same_student_address = obj?.is_same_student_address;
            }
        },
        choose(obj, obj2) {
            obj.is_guardian = !obj?.is_guardian;
            obj2.is_guardian = false;
            this.toggleDisableGuardian = !this.toggleDisableGuardian;
            if (this.toggleDisableGuardian == true) {
                this.guardian.prefix_id = obj?.prefix_id;
                this.guardian.prefix_th = obj?.prefix_th;
                this.guardian.prefix_en = obj?.prefix_en;
                this.guardian.name_th = obj?.name_th;
                this.guardian.name_en = obj?.name_en;
                this.guardian.surname_th = obj?.surname_th;
                this.guardian.surname_en = obj?.surname_en;
                this.guardian.phone_number = obj?.phone_number;
                this.guardian.career = obj?.career;
                this.guardian.position = obj?.position;
                this.guardian.work_place = obj?.work_place;
                this.guardian.email = obj?.email;
            } else {
                this.defaultGuardianData();
            }
        },
        updateSameAddress(address, form){
            if(this.checkFather && form == "Father"){
                this.fetchTrigger = !this.fetchTrigger
                this.otherAddress = address
            }
            else if(this.checkMother && form == "Mother"){
                this.otherAddress = address
                this.fetchTrigger = !this.fetchTrigger
            }
        },
        sameData(obj) {
            if (this.toggleDisableGuardian == true) {

                if(obj.is_guardian){
                    this.guardian.prefix_id = obj?.prefix_id;
                    this.guardian.prefix_th = obj?.prefix_th;
                    this.guardian.prefix_en = obj?.prefix_en;
                    this.guardian.name_th = obj?.name_th;
                    this.guardian.name_en = obj?.name_en;
                    this.guardian.surname_th = obj?.surname_th;
                    this.guardian.surname_en = obj?.surname_en;
                    this.guardian.phone_number = obj?.phone_number;
                    this.guardian.career = obj?.career;
                    this.guardian.position = obj?.position;
                    this.guardian.work_place = obj?.work_place;
                    if(this.stepActive == 5){
                        this.guardian.email = obj?.email;
                        this.guardian.salary = obj?.salary;
                        this.guardian.is_same_student_address = obj?.is_same_student_address;
                    }
                }
            }
        },
        processPrefix_TH(obj) {
            if (obj.prefix_th !== "") {
                obj.prefix_en =
                    this.prefixes.find((item) => item.id == obj?.prefix_th)?.text_en;
            }
        },
        processPrefix_EN(obj) {
            if (obj.prefix_en !== "") {
                obj.prefix_th = this.prefixes.find((item) => item.text_en == obj?.prefix_en).id
            }
        },
        isEngLetter(e) {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if (/^[A-Za-z. ]+$/.test(char)) return true;
            // Match with regex
            else e.preventDefault(); // If not match, don't add to input text
        },
        isThaiLetter(e) {
            let char = String.fromCharCode(e.keyCode); // Get the character
            if (/^[฀-๿a-zA-Z'. ]+$/.test(char)) return true;
            // Match with regex
            else e.preventDefault(); // If not match, don't add to input text
        },
        validate() {
            this.$refs.form.validate();
        },
        async fetchInitData() {
            try {
                this.$emit("loadingUpdate", 1);
                let data = await getPersonalDetail();
                data.prefix.map((item) => {
                    if (
                        item.text_th != "เด็กชาย" &&
                        item.text_th != "เด็กหญิง" &&
                        item.text_th != "ด.ช." &&
                        item.text_th != "ด.ญ."
                    ) {
                        this.prefixes.push(item);
                        this.prefixEN.push(item.text_en);
                    }
                });

                const {
                    data: { data: salary },
                } = await services.getSalary();

                this.salaryRanges = [...salary.salary];

                if (this.stepActive == 5 || this.from == "candidates")
                    this.fetchInitStudentQuery();
                else{
                    this.isSet = true
                }
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
        onChangeData() {
            this.$emit("formValidate", this.$refs?.form?.value);
        },
        async fetchInitStudentQuery() {
            try {
                this.$emit("loadingUpdate", 1);
                const body = {
                    query: {
                        selects: {
                            id: true,
                            student_parent_detail: {
                                id: true,
                            },
                        },
                        relations: {
                            student_parent_detail: true,
                        },
                    },
                };
                if (this.from == "candidates") {
                    body["id"] = this.applicantId;
                    body.query.selects.student_parent_detail = {
                        ...body.query.selects.student_parent_detail,
                        family_status: true,
                        is_siblings_study_together: true,
                        siblings_name: true,
                        siblings_surname: true,
                        siblings_grade: true,
                        siblings_house: true,
                        student_allowance_by: true,
                    };
                } else if (this.stepActive == 5) {
                    body["token"] = localStorage.getItem("token");
                }

                let res = await services.getStudentWithQuery(body);
                const student_parent_detail_id =
                    res.data.data.student.student_parent_detail.id;
                const {
                    data: {
                        data: { student_parents },
                    },
                } = await services.getStudentParents(student_parent_detail_id);
                this.autoFillDataFromDb(student_parents);
                if (this.from == "candidates") {
                    this.student_parent_detail.family_status = res.data.data.student.student_parent_detail.family_status;
                    this.student_parent_detail.is_siblings_study_together = res.data.data.student.student_parent_detail.is_siblings_study_together
                    this.student_parent_detail.siblings_name = res.data.data.student.student_parent_detail.siblings_name
                    this.student_parent_detail.siblings_surname = res.data.data.student.student_parent_detail.siblings_surname
                    this.student_parent_detail.siblings_grade = res.data.data.student.student_parent_detail.siblings_grade
                    this.student_parent_detail.siblings_house = res.data.data.student.student_parent_detail.siblings_house
                    this.student_parent_detail.student_allowance_by = res.data.data.student.student_parent_detail.student_allowance_by;
                }
                this.isSet = true
            }finally {
                this.$emit("loadingUpdate", -1);
            }
        },
        async autoFillDataFromDb(data) {
            try {
                this.$emit("loadingUpdate", 1);
                const dataFill = [
                    "prefix_id",
                    "name_th",
                    "name_en",
                    "surname_en",
                    "surname_th",
                    "phone_number",
                    "parent_type",
                    "is_guardian",
                ];
                if (this.from == "candidates") {
                    const candidateDataFill = [
                        "address",
                        "career",
                        "province",
                        "district",
                        "email",
                        "is_same_student_address",
                        "postal_code",
                        "salary",
                        "subdistrict",
                        "position",
                        "work_place",
                        "prefix_th",
                        "prefix_en",
                    ];
                    dataFill.push(...candidateDataFill);
                }
                let father = null;
                let mother = null;
                let guardian = null;
                data.forEach(async (parent) => {
                    if (parent.parent_type == "FATHER") {
                        father = parent;
                    }
                    if (parent.parent_type == "MOTHER") {
                        mother = parent;
                    }
                    if (parent.parent_type == "GUARDIAN") {
                        guardian = parent;
                    }
                });

                if (father) {
                    this.hasFather = true;
                    dataFill.forEach((key) => {
                        if (key == "prefix_id") {
                            // this.father["prefix_th"] = father[key].id;
                            // this.father["prefix_en"] = father[key].text_en;
                            this.father["prefix_id"] = father[key];
                        } else if (
                            key == "province" ||
                            key == "district" ||
                            key == "subdistrict" ||
                            key == "salary"
                        ) {
                            this.father[key] = father[key]?.value;
                        } else if (key == "is_same_student_address") {
                            this.father[key] = father[key];
                            this.showAddressFather = !father[key];
                        } else this.father[key] = father[key];
                    });
                    this.fetchTrigger = !this.fetchTrigger
                } else {
                    this.hasFather = false;
                }

                if (mother) {
                    this.hasMother = true;
                    dataFill.forEach((key) => {
                        if (key == "prefix_id") {
                            // this.mother["prefix_th"] = mother[key].id;
                            // this.mother["prefix_en"] = mother[key].text_en;
                            this.mother["prefix_id"] = mother[key];
                        } else if (
                            key == "province" ||
                            key == "district" ||
                            key == "subdistrict" ||
                            key == "salary"
                        ) {
                            this.mother[key] = mother[key]?.value;
                        } else if (key == "is_same_student_address") {
                            this.mother[key] = mother[key];
                            this.showAddressMother = !mother[key];
                        } else this.mother[key] = mother[key];
                    });
                    this.fetchTrigger = !this.fetchTrigger
                } else {
                    this.hasMother = false;
                }
                if (guardian) {
                    dataFill.forEach((key) => {
                        if (key == "prefix_id") {
                            // this.guardian["prefix_th"] = guardian[key].id;
                            // this.guardian["prefix_en"] = guardian[key].text_en;
                            this.guardian["prefix_id"] = guardian[key];
                        } else if (
                            key == "province" ||
                            key == "district" ||
                            key == "subdistrict" ||
                            key == "salary"
                        ) {
                            this.guardian[key] = guardian[key]?.value;
                        } else if (key == "is_same_student_address") {
                            this.guardian[key] = guardian[key];
                            this.showAddressGuardian = !guardian[key];
                        } else this.guardian[key] = guardian[key];

                        this.toggleDisableGuardian = false;
                        this.checkFather = false;
                        this.checkMother = false;
                    });
                    this.fetchTrigger = !this.fetchTrigger
                } else {
                    if (father != null && father["is_guardian"] == true) {
                        this.checkFather = false;
                        this.toggleDisableGuardian = false;
                        this.chooseFatherAsParent()

                    } else if (
                        mother != null &&
                        mother["is_guardian"] == true
                    ) {
                        this.checkMother = false;
                        this.toggleDisableGuardian = false;
                        this.chooseMotherAsParent()
                    }
                }
            } finally {
                this.$emit("loadingUpdate", -1);
            }
        },
    },
    props: {
        checkValidate: Boolean,
        callAutoFill: Boolean,
        stepActive: Number,
        applicantId: Number,
        widthProp: {
            default: "690",
            type: String,
        },
        registrationState: {
            default: "all",
            type: String,
        },
        from: {
            default: "all",
            type: String,
        },
    },
    emits: ["formValidate"],
    computed: {
        locale(){
            return i18n.locale
        },
        responsiveWithFrom() {
            if (this.from == "candidates") return 3;
            return 6;
        },
        showSectionCondition() {
            try {
                let allow_state = [
                    RegistrationStatusEnum.SUCCESSFUL_CONFIRMATION_DETAIL,
                    RegistrationStatusEnum.SUCCESSFUL_ENROLLMENT
                ];
                if (this.from == "all") return false;
                if (
                    this.from == "candidates" &&
                    allow_state.includes(this.registrationState)
                )
                    return true;
                return false;
            } catch (error) {
                return false;
            }
        },
        disabledRules() {
            if (this.stepActive == 5 && this.$route.query.action == "view")
                return true;

            return false;
        },
    },
    watch: {
        checkValidate: function () {
            this.validate();
        },
        callAutoFill: function () {
            this.autoFill();
        },
        checkFather(){
            if(this.checkFather){
                let address = this.$refs?.fatherAddress?.$data?.parentAddress
                this.updateSameAddress(address, "Father")
            }
        },
        checkMother(){
            if(this.checkMother){
                let address =this.$refs?.motherAddress?.$data?.parentAddress
                this.updateSameAddress(address, "Mother")
            }
        }
    },
    mounted() {
        this.fetchInitData();
    },
    updated() {
        this.onChangeData();
    },
    components: { AddressForm },
};

const getPersonalDetail = async () => {
    const {
        data: { data },
    } = await services.getPersonalDetail();
    return data;
};
</script>

<style scoped>
.form-label{
    font-size: 18px;
}
.remark-text {
    font-weight: 400;
    font-size: 16px;
    color: red;
}
</style>
